import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import Navbar from '../components/Navbar';
import Layout from './Layout';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import About from '../components/About';
import Service from '../components/Service';
import Loading from '../components/Loading';
import  { getSite } from '../tools/fetcher';
import Testimonial from '../components/Testimonial';

export default function Homepage() {
    const { isPending, isError, data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        let x = 1;
        const interval = setInterval(() => {
            const params = new URLSearchParams(window.location.search);
            const section = params.get('section');
            const element = document.getElementById(section);
            if (section) {
                console.log('CLEAR');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    clearInterval(interval);
                }
            }
            x += 1;
            if (x > 50) {
                // 10 seconds
                clearInterval(interval);
            }
        }, 200);
        return () => clearInterval(interval);
    }, []); // Empty dependency array ensures this runs only once on mount

    if (isPending) {
        return <Loading />;
    }
    if (isError) {
        return <Loading>Error loading data</Loading>;
    }

    return (
        <Layout className="min-w-[360px] font-inter">
            <div className="px-4 sm:px-6 lg:px-8 xl:px-[140px] sm:py-6">
                <Navbar data={data} className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="hero"
                className="bg-hero-pattern bg-primary-gray-99 px-4 py-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:pt-[100px] md:pb-[321px]"
            >
                <Hero className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="about"
                className="bg-white px-4 py-[60px] sm:px-6 lg:px-8 xl:px-[140px] sm:pt-[100px]"
            >
                <About className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="service"
                className="bg-service-pattern bg-primary-gray-99 px-4 py-[60px] sm:rounded-[20px] sm:px-6 sm:py-[120px] lg:px-8 xl:mx-[70px]"
            >
                <Service className={'max-w-[1160px] mx-auto'} />
            </div>
            <div
                id="testimonial"
                className="bg-white px-4 py-[60px] sm:px-6 sm:py-[120px] lg:px-8 xl:px-[140px]"
            >
                <Testimonial
                    className={'px-4 sm:px-6 lg:px-8 xl:px-[140px]'}
                    classNameSlider={'sm:px-6 lg:px-8 xl:px-[140px]'}
                    innerWidth={'max-w-[1160px]'}
                />
            </div>
            <div
                id="footer"
                className="bg-footer-pattern bg-primary-green-101 px-4 pt-[60px] pb-[20px] relative sm:pt-[100px] sm:pb-[80px] sm:px-6 lg:px-8 xl:px-[140px]"
            >
                <Footer data={data} className={'max-w-[1160px] mx-auto'} />
            </div>
        </Layout>
    );
}
